<div class="card-educational-material">
  <a [routerLink]="['/materiaali', educationalMaterial.id]" class="header">
    <div class="row g-0">
      <div class="col-12 col-sm-4 col-md-12 col-lg-5 text-center text-sm-start text-md-center text-lg-start mb-3 mb-lg-0">
        <img
          [src]="educationalMaterial.thumbnail"
          class="img-fluid border"
          [alt]="'demo.educationalMaterial.cover.alt' | translate" />
      </div>

      <div class="col-12 col-sm-8 col-md-12 col-lg-7 px-sm-3">
        <h3>{{ educationalMaterial.name[lang] }}</h3>

        @if (educationalMaterial.description) {
          <p>{{ educationalMaterial.description[lang] | truncate: [75] }}</p>
        }

        <ul class="list-unstyled authors">
          @for (author of educationalMaterial.authors; track author) {
            <li>{{ author.authorname }}</li>
          }
        </ul>
      </div>
    </div>
  </a>

  @if (educationalMaterial.keywords?.length > 0) {
    <app-taglist
      [elementId]="'material-keywords' + educationalMaterial.id"
      [tags]="keywords"
      [title]="'collections.meta.keywords' | translate"
      [card]="true"
      [hiddenTagsAmount]="educationalMaterial.keywords.length - keywords.length"
      property="value"
      searchProperty="keywordkey"
    filterType="keywords"></app-taglist>
  }
  <!--keywords-->

  @if (educationalMaterial.educationalLevels?.length > 0) {
    <app-taglist
      [elementId]="'material-educationalLevels' + educationalMaterial.id"
      [tags]="educationalLevels"
      [title]="'collections.meta.educationalLevels' | translate"
      [card]="true"
      [hiddenTagsAmount]="educationalMaterial.educationalLevels.length - educationalLevels.length"
      property="value"
      searchProperty="educationallevelkey"
    filterType="educationalLevels"></app-taglist>
  }
  <!--educationalLevels-->

  <div class="details d-flex flex-row">
    <div class="license text-dark">{{ educationalMaterial.license.value }}</div>
    <div class="type ms-auto">
      <img
        src="assets/img/icons/learning-resource-types/{{
          educationalMaterial.learningResourceTypes[0].learningresourcetypekey
        }}.svg"
        class="img-icon"
        aria-hidden="true" />
      {{ educationalMaterial.learningResourceTypes[0].value }}
    </div>
  </div>

  @if (educationalMaterial.viewCounter && educationalMaterial.downloadCounter) {
    <div class="counters">
      <div class="counter">
        <i class="fa fa-fw fa-eye" aria-hidden="true"></i>
        <span class="visually-hidden">{{ "demo.educationalMaterial.viewCount" | translate }}:</span>
        {{ educationalMaterial.viewCounter }}
      </div>
      <div class="counter">
        <i class="fa fa-fw fa-download" aria-hidden="true"></i>
        <span class="visually-hidden">{{ "demo.educationalMaterial.downloadCount" | translate }}:</span>
        {{ educationalMaterial.downloadCounter }}
      </div>
    </div>
  }
</div>
